import * as React from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

function SvgSpinner(
  { title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      aria-labelledby={titleId}
      fill='none'
      height={24}
      ref={svgRef}
      viewBox='0 0 24 24'
      width={24}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        clipRule='evenodd'
        d='M11 4a1 1 0 011-1 9 9 0 019 9 1 1 0 11-2 0 7.001 7.001 0 00-7-7 1 1 0 01-1-1z'
        fill='currentColor'
        fillRule='evenodd'
      >
        <animateTransform
          attributeName='transform'
          attributeType='XML'
          dur={props.dur}
          from='0 12 12'
          repeatCount='indefinite'
          to='360 12 12'
          type='rotate'
        />
      </path>
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgSpinner);
export default ForwardRef;
